export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-database-919067782ca7fb1fc900db69257b486b.svg";